// src/components/DonationBubble.js
import React from 'react'; // <-- Quitamos useState, useRef, useCallback
import { Link } from 'react-router-dom';

const formatTimestamp = (timestamp) => {
    if (!timestamp) return 'hace un momento';

    let date;

    // Verificamos si el timestamp es un objeto de Firestore o un número de TypeSense
    if (timestamp.toDate) {
      // Es un objeto Timestamp de Firestore, usamos el método .toDate()
      date = timestamp.toDate();
    } else if (typeof timestamp === 'number') {
      // Es un número (timestamp de Unix en segundos), lo convertimos a milisegundos
      date = new Date(timestamp * 1000);
    } else {
      // Si llega en otro formato inesperado, evitamos que la app se rompa
      return 'fecha inválida';
    }

    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);

    if (seconds < 60) return `hace ${seconds}s`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `hace ${minutes}m`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `hace ${hours}h`;
    const days = Math.floor(hours / 24);
    if (days < 30) return `hace ${days}d`;
    const months = Math.floor(days / 30);
    if (months < 12) return `hace ${months}mes`;
    const years = Math.floor(months / 12);
    return `hace ${years}a`;
};


// --- ¡NUEVAS PROPS! ---
const DonationBubble = ({ donation, showAmount, isExpanded, onMouseEnterBubble, onMouseLeaveBubble }) => {
    // Ya no necesitamos estado interno ni refs aquí

    // Datos del donante (sin cambios)
    const isAnon = donation.isAnonymous || !donation.donorUsername;
    const displayName = isAnon ? "Donante Anónimo" : `@${donation.donorUsername}`;
    const profileLink = isAnon ? "#" : `/profile/${donation.donorUsername}`;
    const avatarSrc = donation.donorAvatarURL || `https://placehold.co/40x40/556688/FFFFFF?text=${displayName.charAt(0).toUpperCase()}`;
    const NameComponent = isAnon ? 'span' : Link;

    // Monto y Divisa (sin cambios)
    const currencyCode = donation.currency ? donation.currency.toUpperCase() : 'USD';
    const formattedAmount = showAmount && donation.amount
        ? `${donation.amount.toFixed(2)} ${currencyCode}`
        : null;

    return (
        // Contenedor principal: USA LAS FUNCIONES DEL PADRE
        <div
            className="relative inline-block"
            onMouseEnter={() => onMouseEnterBubble(donation.id)} // <-- Llama a la función del padre con el ID
            onMouseLeave={onMouseLeaveBubble}                   // <-- Llama a la función del padre
        >
            {/* Contenedor visible (Avatar y Monto) */}
            <div className="flex items-center p-1 rounded-full bg-gray-700 shadow-md cursor-pointer transition-colors duration-200 hover:bg-gray-600">
                <img
                    src={avatarSrc}
                    alt={displayName}
                    className="w-8 h-8 rounded-full object-cover border-2 border-gray-500 flex-shrink-0"
                />
                {formattedAmount && (
                    <span className="ml-1 mr-1 text-sm font-bold text-green-400">{formattedAmount}</span>
                )}
            </div>

            {/* Contenido Expandido: USA EL ESTADO DEL PADRE */}
            <div
                className={`absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-max max-w-xs sm:max-w-sm z-20 bg-gray-800 rounded-lg shadow-xl p-3 text-left transition-all duration-300 ease-out ${
                    isExpanded // <-- Ahora es una prop del padre
                        ? 'opacity-100 translate-y-0 pointer-events-auto'
                        : 'opacity-0 translate-y-1 pointer-events-none'
                }`}
            >
                {/* Contenido interno (sin cambios) */}
                <div className="flex items-center justify-between mb-1">
                    <NameComponent
                        to={profileLink}
                        className={`text-sm font-semibold ${!isAnon ? 'text-indigo-400 hover:underline' : 'text-gray-300'}`}
                    >
                        {displayName}
                    </NameComponent>
                    {formattedAmount && (
                        <span className="ml-3 text-sm font-bold text-green-400">{formattedAmount}</span>
                    )}
                </div>
                {donation.message && (
                    <p className="text-xs text-gray-300 italic whitespace-normal mt-1">"{donation.message}"</p>
                )}
                {/* Timestamp (opcional) */}
                 {donation.createdAt && (
                    <p className="text-xs text-gray-400 mt-1">{formatTimestamp(donation.createdAt)}</p>
                 )}
                <div className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-8 border-l-transparent border-r-8 border-r-transparent border-t-8 border-t-gray-800"></div>
            </div>
        </div>
    );
};

export default DonationBubble;